import { render, staticRenderFns } from "./QueryMonkeyC.vue?vue&type=template&id=36e0ea56&"
import script from "./QueryMonkeyC.vue?vue&type=script&lang=js&"
export * from "./QueryMonkeyC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports